module.exports = __webpack_public_path__ + "media/dashboard/assets/images/dial-pad-4be6cd0a409b8b3da9af6947921e81e6.svg";